import Banner from "../components/landing/Banner";
import Contact from "../components/landing/Contact";
import FeatCustomer from "../components/landing/FeatCustomer";
import Features from "../components/landing/Features";
import HowDoesWork from "../components/landing/HowDoesWork";
import Pricing from "../components/landing/Pricing";
import Testimonials from "../components/landing/Testimonials";

const Landing = () => {
    return (
        <>
            <Banner />
            <Features />
            <HowDoesWork />
            <Pricing />
            <FeatCustomer />
            <Testimonials />
            <Contact />
        </>
    );
};

export default Landing;
